__turbopack_context__.v({
  "blogBody": "BlogLayout-module-scss-module__KrW3Xq__blogBody",
  "dark": "BlogLayout-module-scss-module__KrW3Xq__dark",
  "light": "BlogLayout-module-scss-module__KrW3Xq__light",
  "rightGroup": "BlogLayout-module-scss-module__KrW3Xq__rightGroup",
  "separateSearchBar": "BlogLayout-module-scss-module__KrW3Xq__separateSearchBar",
  "slantedContainer": "BlogLayout-module-scss-module__KrW3Xq__slantedContainer",
  "topBar": "BlogLayout-module-scss-module__KrW3Xq__topBar",
});
